module.exports = __webpack_public_path__ + "img/type12.9f9ffa7c.png";